import React, {useState, useEffect} from 'react';
import {getTemplates, updateNewPlan, deletePlan} from './../requests';
import Popup from "reactjs-popup";

const Templates = () => {
    const [templates, setTemplates] = useState([]);
    const [templateData, setTemplateData] = useState({});
    const [deletePopup, setDeletePopup] = useState(false);
    const [renamePopup, setRenamePopup] = useState(false);
    const [newName, setNewName] = useState("");
    const [userId, setUserId] = useState("");

    const Update = () => {
        const data_request = {
            user_id: document.getElementById("user_id").value,
        }
        getTemplates(data_request)
        .then(data=>{
            const temp = [];
            data.sort((t1, t2) => t2.start_live-t1.start_live)
            for(let i = 0; i < data.length; i++){
                if(data[i].template_name != ""){
                    temp.push(
                        <div className="template" key={i}>
                            <h3>{data[i].template_name}</h3>
                            <div className="btn_group">
                                <button onClick={()=>{
                                    setTemplateData(data[i]);
                                    setDeletePopup(false);
                                    setRenamePopup(true);
                                }}>Rename</button>
                                <p>|</p>
                                <button onClick={()=>{
                                    setTemplateData(data[i]);
                                    setRenamePopup(false);
                                    setDeletePopup(true);
                                }}>Delete</button>
                            </div>
                        </div>
                    )
                }
            }
            setTemplates(temp);
        })
    }


    const Rename = () => {
        setRenamePopup(false);
        let newState = JSON.parse(JSON.stringify(templateData));
        newState.template_name= newName;
        updateNewPlan(newState)
            .then((data)=>{
                setTemplates([]);
                Update();
            })

    }

    const Delete = () => {
        setDeletePopup(false);
        const data = {
            id: templateData.id
        }
        deletePlan(data)
            .then(data=>{
                setTemplates([]);
                Update();
            })
    }

    useEffect(()=>{
        let user_id = document.getElementById("user_id").value;
        const handler = setTimeout(() => {
            let val = document.getElementById("user_id").value;
            if (val !== user_id){
                clearInterval(handler);
                setUserId(val);
            }
        }, 500)
    }, [])

    useEffect(() => {
        if (userId !== "")
            Update();
    }, [userId]);

    return(
        <div className="wrap">
            <div className="description"><h2>Select a template to rename or delete</h2></div>
            <div className="templates_list">
                {templates}
            </div>

            <Popup
                open={renamePopup}
                closeOnDocumentClick
                onClose={()=> {
                    setRenamePopup(false);
                }}
                contentStyle={{
                    width: "40%",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
                }}
            >
                <div className="modal">
                    <h3 style={{
                        fontWeight: 500,
                    }}>Rename this template</h3>
                    <h3 style={{
                        fontWeight: 500,
                        fontStyle: "italic"
                    }}>
                        {templateData.template_name}
                    </h3>

                    <div className="inpt">
                        <label htmlFor="rename"
                            style={{
                                fontSize: "1.4rem",
                                textAlign: "left",
                            }}>
                                Enter a new name for this template
                        </label>
                        <input id="rename" type="text" onChange={(event => setNewName(event.target.value ))}/>
                    </div>
                    <div className="btn_popup">
                        <button onClick={()=>setRenamePopup(false)}>Cancel</button>
                        <button onClick={Rename}>Save</button>
                    </div>
                </div>
            </Popup>

            <Popup
                open={deletePopup}
                closeOnDocumentClick
                onClose={()=> {
                    setDeletePopup(false);
                }}
                contentStyle={{
                    width: "40%",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
                }}
            >
                <div className="modal">
                    <h3>Deleting template</h3>
                    <h3 style={{
                        fontStyle: "italic"
                    }}>{templateData.template_name}</h3>
                    <div className="btn_popup">
                        <button onClick={()=>setDeletePopup(false)}>Cancel</button>
                        <button onClick={Delete}>Delete</button>
                    </div>
                </div>
            </Popup>
        </div>
    )
}
export default Templates;